/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-05-29 15:04:38
 *
 *******************************************************/
// @flow

export const NUMBER_PRODUCT_VISIBILITY_RULES = 10;
